import React, {useEffect, useState} from 'react';
import {labels, permissionGroups} from '../../util/uiconstants';
import {EngagementAccessType, EngagementSource} from '../../util/enumerations';
import ContextMenu from '../Common/contextMenu';
import {EngagementStatus} from '../../util/enumerations.js';
import EngagementRemoveModal from './engagementRemoveModal';
import EngagementDeleteModal from './EngagementDeleteModal';
import OverrideArchiveDeadlineDateModal from './overrideArchiveDeadlineDateModal';
import {shallowEqual, useSelector} from 'react-redux';
import {adobeAnalytics} from '@ey/voltron-analytics';
import {clickActionArgs} from '../Common/Adobe Analytics/actionHelpers.js';
import {
	eventTypes,
	controlTypes,
	locationInPages,
	clickActionNames
} from '../Common/Adobe Analytics/constants.js';
import Utility from '../../util/utils';
import BlockerInformationalModal from './blockerInformationalModal';
import EyServiceGatewayModal from './eyServiceGatewayModal.js';
import EngagementInvalidModal from './engagementInvalidModal';

const CogWheel = (props) => {
	const {
		data,
		incomplete,
		workspaceID,
		id,
		doRefreshDashboard,
		userPermissions,
		datacenterid,
		engagementDesc = '',
		workspaceDesc = ''
	} = props;
	const {
		engagementstatus,
		engagementisprofilecomplete,
		incountryuri,
		isinterimreviewengagement,
		engagementaccesstypeid,
		engagementStatus,
		isclientcodevalid,
		isengagementcodevalid,
		hasengagementpassedalloweddays
	} = data;
	const trackEvent = adobeAnalytics.useAdobeAnalyticsTrack();

	const timeline = useSelector((store) => {
		let timelineData = {};
		if (store.timeline && Array.isArray(store.timeline.timeline)) {
			const timelineElement = store.timeline.timeline.find(
				(element) => element.id == id /* loose comparison by intent */
			);

			timelineData = (timelineElement && timelineElement.data) || timelineData;
		}

		return timelineData;
	}, shallowEqual);

	const notifications = useSelector((store) => store.notifications);
	const featureConfiguration = useSelector(
		(store) => store.featureConfiguration
	);

	const [forceRefreshCounter, setForceRefreshCounter] = useState(1);
	const [showRemoveModalState, setshowRemoveModalState] = useState(false);
	const [showDeleteModalState, setshowDeleteModalState] = useState(false);
	const [
		showOverrideArchiveDeadlineDateModal,
		setShowOverrideArchiveDeadlineDateModal
	] = useState(false);
	const [showBlockerInformationalModal, setShowBlockerInformationalModal] =
		useState(false);
	const [
		blockerInformationalNotification,
		setBlockerInformationalNotification
	] = useState({});
	const [showEyServiceGatewayModal, setShowEyServiceGatewayModal] =
		useState(false);
	const [
		shouldDisplayServiceGatewayModal,
		setShouldDisplayServiceGatewayModal
	] = useState(false);
	const [showInvalidEngagementModalState, setShowInvalidEngagementModalState] =
		useState(false);

	useEffect(() => {
		setShouldDisplayServiceGatewayModal(
			Utility.shouldDisplayServiceGatewayModal(timeline)
		);
	}, [timeline]);

	//will force context menu to close
	const updateRefreshCounter = () => {
		setForceRefreshCounter((prevState) => prevState + 1);
	};

	const trackClickAction = (name, url = undefined) => {
		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				`${name}`,
				controlTypes.button,
				locationInPages.engagementMenu,
				url
			)
		);
	};

	const routeToManageTeam = (e) => {
		if (
			(!isclientcodevalid && hasengagementpassedalloweddays) ||
			(!isengagementcodevalid && hasengagementpassedalloweddays)
		) {
			setShowInvalidEngagementModalState(true);
			return;
		}

		if (e) {
			let notificationToBeDisplayed =
				Utility.getBlockerInformationalNotification(
					notifications?.notificationdetails,
					datacenterid
				);
			if (notificationToBeDisplayed) {
				setBlockerInformationalNotification(notificationToBeDisplayed);
				setShowBlockerInformationalModal(true);
				return;
			}
		}

		if (
			shouldDisplayServiceGatewayModal &&
			featureConfiguration?.isservicegatewaymessagingenabled
		) {
			setShowEyServiceGatewayModal(true);
			return;
		}

		let manageTeamUrl = incountryuri + '/manageteam?' + '&engagementid=' + id;
		trackClickAction(clickActionNames.manageTeam, manageTeamUrl);
		window.location.href = manageTeamUrl;
	};

	const getMenuItems = () => {
		let items = [];

		if (engagementaccesstypeid === EngagementAccessType.IndependenceOnly) {
			if (isRemoveEngagementApplicable()) {
				items.push(getRemoveEngagementItem());
			}
		} else {
			if (isEditEngagementApplicable()) {
				items.push(getEditEngagementItem());
				items.push(getEditWorkspaceItem());
			}

			if (isManageTeamApplicable()) {
				items.push(getManageTeamItem());
			}

			if (isRemoveEngagementApplicable()) {
				items.push(getRemoveEngagementItem());
			}

			if (isDeleteEngagementApplicable()) {
				items.push(getDeleteEngagementItem());
			}

			if (isOverrideArchiveDateApplicable()) {
				items.push(getOverrideArchiveDateItem());
			}

			if (isCRPApplicable()) {
				items.push(getCRPItem());
			}
		}

		return items;
	};

	const isEditEngagementApplicable = () => {
		return engagementstatus != EngagementStatus.ContentDeliveryInProgress;
	};

	const isManageTeamApplicable = () => {
		return canAccessAcitveAndSimilarEngagements();
	};

	const canAccessAcitveAndSimilarEngagements = () => {
		let eStat = engagementstatus;

		if (!engagementisprofilecomplete) {
			return true;
		}

		if (incomplete) {
			return false;
		}

		if (isContentDeliveryInProgress() === true) {
			return false;
		}

		if (
			eStat === EngagementStatus.Active ||
			eStat === EngagementStatus.Restored ||
			eStat === EngagementStatus.MarkedForDeletion
		) {
			return true;
		} else {
			return false;
		}
	};

	const isContentDeliveryInProgress = () => {
		const isContentDeliveryInProgress =
			timeline &&
			timeline.metrics &&
			timeline.metrics.engagementAlerts &&
			timeline.metrics.engagementAlerts.hasContentDeliveryInProgress;

		return isContentDeliveryInProgress === true;
	};

	const isRemoveEngagementApplicable = () => {
		return (
			engagementstatus !== EngagementStatus.ContentDeliveryInProgress &&
			(engagementisprofilecomplete ||
				engagementaccesstypeid === EngagementAccessType.IndependenceOnly)
		);
	};

	const isDeleteEngagementApplicable = () => {
		return (
			(data.engagementstatus !== EngagementStatus.MarkedForDeletion &&
				data.isengagementaccessible) ||
			data.engagementstatus === EngagementStatus.ContentDeliveryInProgress ||
			!data.engagementisprofilecomplete
		);
	};

	const isOverrideArchiveDateApplicable = () => {
		if (
			data?.engagementstatus === EngagementStatus.Restored ||
			data?.engagementsourceid === EngagementSource.Restore ||
			data?.engagementsourceid === EngagementSource.RestoreException
		) {
			return false;
		} else {
			return canAccessAcitveAndSimilarEngagements();
		}
	};

	const isCRPApplicable = () => {
		let perm = userPermissions && userPermissions.userpermissions;

		if (perm) {
			var item = perm.find(
				(x) => x.groupname === permissionGroups.Global_ReviewPortal
			);
			return item != null ? true : false;
		}
	};

	const getEditEngagementItem = () => {
		const pathname = '/editengagement';
		const search = '?workspaceid=' + workspaceID + '&engagementid=' + id;
		let ret = {
			linkTo: {
				pathname,
				search
			},
			label: labels.contextMenuEditEngagement,
			onClick: () => {
				trackClickAction(
					clickActionNames.editEngagement,
					`${window.location.origin}${pathname}${search}`
				);
			}
		};
		return ret;
	};

	const getEditWorkspaceItem = () => {
		const pathname = '/editworkspace';
		const search = '?workspaceid=' + workspaceID;
		let ret = {
			linkTo: {
				pathname,
				search,
				state: {
					oldPath: '/'
				}
			},
			label: labels.contextMenuEditWorkspace,
			onClick: () => {
				trackClickAction(
					clickActionNames.editWorkspace,
					`${window.location.origin}${pathname}${search}`
				);
			}
		};
		return ret;
	};

	const getManageTeamItem = () => {
		let ret = {
			linkTo: null,
			onClick: routeToManageTeam,
			label: labels.manageTeam
		};
		return ret;
	};

	const getRemoveEngagementItem = () => {
		let ret = {
			linkTo: null,
			onClick: showRemoveModal,
			label: labels.contextMenuRemoveEngagement
		};
		return ret;
	};

	const showRemoveModal = () => {
		updateRefreshCounter();
		setshowRemoveModalState(true);
		trackClickAction(clickActionNames.removeEngagement);
	};

	const hideRemoveModal = () => {
		updateRefreshCounter();
		setshowRemoveModalState(false);
		doRefreshDashboard();
	};

	const quitRemoveModal = () => {
		updateRefreshCounter();
		setshowRemoveModalState(false);
	};

	const getDeleteEngagementItem = () => {
		let ret = {
			linkTo: null,
			onClick: showDeleteModal,
			label: labels.contextMenuDeleteEngagement
		};

		return ret;
	};

	const showDeleteModal = () => {
		updateRefreshCounter();
		setshowDeleteModalState(true);
		trackClickAction(clickActionNames.deleteEngagement);
	};

	const hideDeleteModal = () => {
		updateRefreshCounter();
		setshowDeleteModalState(false);
		doRefreshDashboard();
	};

	const quitDeleteModal = () => {
		updateRefreshCounter();
		setshowDeleteModalState(false);
	};

	const getOverrideArchiveDateItem = () => {
		let ret = {
			linkTo: null,
			onClick: showOverrideArchiveDateModal,
			label: labels.contextMenuOverrideArchiveDate
		};
		return ret;
	};

	const showOverrideArchiveDateModal = (e) => {
		e.preventDefault(); //
		setShowOverrideArchiveDeadlineDateModal(true);
		trackClickAction(clickActionNames.overrideArchiveDate);
	};

	const getCRPItem = () => {
		const pathname = '/crp';
		const search =
			'?eid=' + id + '&T=1' + '&isInt=' + isinterimreviewengagement;
		let ret = {
			linkTo: {
				pathname,
				search,
				state: {previousUrl: window.location.pathname}
			},
			label: labels.contextMenucrp,
			onClick: () => {
				trackClickAction(
					clickActionNames.crp,
					`${window.location.origin}${pathname}${search}`
				);
			}
		};
		return ret;
	};

	const hideInvalidEngagementModal = () => {
		setShowInvalidEngagementModalState(false);
	};

	return (
		<React.Fragment>
			<ContextMenu
				key={forceRefreshCounter}
				iconHover={labels.options}
				iconName={'more-dots'}
				iconstyleName={'large'}
				menuItems={getMenuItems}
			/>
			<EngagementRemoveModal
				show={showRemoveModalState}
				hide={hideRemoveModal}
				quit={quitRemoveModal}
				{...props}
			/>
			<EngagementDeleteModal
				show={showDeleteModalState}
				hide={hideDeleteModal}
				quit={quitDeleteModal}
				refreshDashboard={doRefreshDashboard}
				{...props}
			/>
			<OverrideArchiveDeadlineDateModal
				show={showOverrideArchiveDeadlineDateModal}
				closeModal={setShowOverrideArchiveDeadlineDateModal}
				engagementId={id}
				workspaceId={workspaceID}
				refreshDashboard={doRefreshDashboard}
			/>
			<BlockerInformationalModal
				notification={blockerInformationalNotification}
				show={showBlockerInformationalModal}
				setShow={setShowBlockerInformationalModal}
				onOkClick={routeToManageTeam}
				engagementId={id}
			/>
			<EyServiceGatewayModal
				show={showEyServiceGatewayModal}
				setShow={setShowEyServiceGatewayModal}
				incountryuri={incountryuri}
				engagementId={id}
				engagementDescription={engagementDesc}
				redirectToManageTeam={true}
			/>
			<EngagementInvalidModal
				show={showInvalidEngagementModalState}
				hide={hideInvalidEngagementModal}
				{...props}
			/>
		</React.Fragment>
	);
};

export default CogWheel;
